import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Select from '../../form/Select'
import Checkbox from '../../form/Checkbox'
import Button from '../../../UniformComponents/Button'

const VerbatimSettingsModal = ({ store }) => {
    let warningText = null

    if (store.questionCodingAvailability.get(store.activeChart?.questionId) === false) {
        warningText = i18n.t('powerpoint.modals.verbatim.warning')
    }

    if (store.presentationCodingAvailability === 'survey') {
        warningText = i18n.t('powerpoint.modals.verbatim.survey-warning')
    }

    if (store.presentationCodingAvailability === 'client') {
        warningText = i18n.t('powerpoint.modals.verbatim.client-warning')
    }

    return (
        <Modal
            show={store.verbatimSettingsModalVisible}
            onClose={store.handleCloseVerbatimSettingsModal}
        >
            <Typography type="h3">{i18n.t('powerpoint.modals.verbatim.title')}</Typography>

            <br />
            {warningText ? (
                <>
                    <Typography type="tiny" cssClass="pp-verbatim-modal-warning">
                        {warningText}
                    </Typography>

                    <br />

                    <Button
                        label={i18n.t('cancel')}
                        cssClass="regular tertiary"
                        onClick={store.handleCloseVerbatimSettingsModal}
                    />
                </>
            ) : (
                <>
                    <Typography type="tiny">
                        {i18n.t(store.activeChart?.questionCoding.categories.length > 1
                            ? 'powerpoint.modals.verbatim.instruction'
                            : 'powerpoint.modals.verbatim.instruction.no-categories')}
                    </Typography>

                    <br />

                    {store.activeChart?.questionCoding.categories.length > 1 ? (
                        <div>
                            <Select
                                label="Category"
                                options={store.activeChart?.codedCategories || []}
                                onBlur={(e) => store.activeChart?.handleChooseCategory(e.value, e.pct)}
                                value={store.activeChart?.pendingChanges.category}
                            />

                            <br />

                            {!!store.activeChart?.pendingChanges.category && (
                                <div>
                                    <Typography type="b">{i18n.t('powerpoint.modals.verbatim.selections', { 1: store.verbatimSlots || 3 })}</Typography>

                                    <Typography type="tiny">
                                        {i18n.t('powerpoint.modals.verbatim.selectionCount',
                                            {
                                                1: store.activeChart?.pendingChanges?.labels?.length || 0,
                                                2: store.verbatimSlots || 3,
                                            })}
                                    </Typography>

                                    <br />

                                    <div className="pp-verbatim-modal-checkbox-container">
                                        {!!store.activeChart?.pendingChanges.category && (
                                            store.activeChart?.labelsForCategory.map(({ label }) => {
                                                const isChecked = store.activeChart?.pendingChanges.labels.includes(label)
                                                return (
                                                    <div
                                                        onClick={() => store.activeChart?.handleChooseLabel(label)}
                                                        className={
                                                            isChecked
                                                                ? 'pp-verbatim-modal-checkbox-selected'
                                                                : 'pp-verbatim-modal-checkbox'
                                                        }
                                                    >
                                                        <Checkbox
                                                            name={label}
                                                            checked={isChecked}
                                                            label={label}
                                                        />
                                                    </div>
                                                )
                                            })
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div>
                            <Button
                                label="Generate coding"
                                cssClass="regular primary"
                                onClick={store.activeChart?.generateCoding}
                            />
                        </div>
                    )}

                    <br />

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            label={i18n.t('cancel')}
                            cssClass="regular tertiary"
                            onClick={store.activeChart?.handleCancelVerbatimChoices}
                        />

                        <Button
                            label={i18n.t('save')}
                            cssClass="regular primary"
                            onClick={store.activeChart?.handleSaveVerbatimChoices}
                        />
                    </div>
                </>
            )}
        </Modal>
    )
}

export default observer(VerbatimSettingsModal)
